import { useCallback } from "react";
import { demoFormUtils } from "@/pages/demo/demo.utils";
import qs from "query-string";
import { useHistory } from "react-router-dom";

export const makeBlurTracking = (fieldName: string, fieldValue: string) => {
  demoFormUtils.track(
    `user_filled_out_${fieldName}`,
    {
      fieldName,
      timestamp: new Date().toISOString()
    },
    {
      [fieldName]: fieldValue
    }
  );
};

export const useBlur = () => {
  const history = useHistory();

  const makeDidBlur = useCallback(
    (fieldName: string, nextValue: string) => {
      if (nextValue) {
        const queryString = qs.parse(window.location.search);

        if (queryString[fieldName] !== nextValue) {
          queryString[fieldName] = nextValue;
          history.replace({
            search: qs.stringify(queryString)
          });
        }
      }
    },
    [history]
  );

  return { makeBlurTracking, makeDidBlur };
};
